module.exports = __webpack_public_path__ + "static/Valtteri-Torikka-7342b69821a6d29adc21474a6cdc13fb.jpeg";